import { Text, UnstyledButton } from "@mantine/core"
import React from "react"

import { Icon } from "@/components/Icon"
import { convertToSlug } from "shared/imports/sharedHelperFunctions"

import classes from "./ButtonWithDescription.module.css"

export interface ButtonWithDescriptionProps {
    icon: string
    iconFamily: string
    title: string
    description: string
    isActive?: boolean
    key?: string
    value: number
    onChange: (value: number | string) => void
}

export const ButtonWithDescription = (props: ButtonWithDescriptionProps) => {
    return (
        <UnstyledButton
            className={classes.button}
            data-active={props.isActive}
            data-cy={`button-with-description-${convertToSlug(props.title)}`}
            aria-label={props.title}
            onClick={() => props.onChange(props.value)}
        >
            <div className={classes.container}>
                <div aria-hidden="true" className={classes.iconContainer} data-active={props.isActive}>
                    <Icon
                        aria-hidden="true"
                        className={classes.icon}
                        data-active={props.isActive}
                        icon={props.isActive ? "check" : props.icon}
                        iconFamily={props.isActive ? "far" : props.iconFamily}
                    />
                </div>
                <div aria-hidden="true" className={classes.titleContainer}>
                    <Text className={classes.title}>{props.title}</Text>
                    <Text className={classes.description}>{props.description}</Text>
                </div>
            </div>
        </UnstyledButton>
    )
}
